import * as yup from "yup";

import { Box, Grid, MenuItem, Typography, makeStyles } from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { Global, css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import {
  activityTagDropdownOptions,
  albumDropdownOptions,
  galleryEventDropdownOptions,
  genreTagDropdownOptions,
  allGalleryEventDropdownOptions,
  allAlbumDropdownOptions,
} from "../v2_actions/dropdown_options";
import { clone, filter, get, last, map, size } from "lodash";
import { matchPath, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FailedPhotoUploadDialog } from "./FailedPhotoUploadDialog";
import { GeneralFormErrors } from "./form/GeneralFormErrors";
import { LoaderPercentProgressContainer } from "../views/uploadgallery/loaderComponent";
import { PhotographUploader } from "./form/PhotographUploader";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { StyledButton } from "../components/CustomButtons/StyledButton";
import { TextField } from "./form/TextField";
import { briefGalleryListForPhotoArt } from "v2_actions/brief_gallery";
import classNames from "classnames";
import { facialRecognitionList } from "v2_actions/facial_recognition";
import { galleryList, galleryUploadCredentialsList } from "../v2_actions/gallery";
import { getUserStoredCountry } from "../v2_actions/auth_country";
import { handleSubmitResult } from "../v2_actions/form";
import { loggedInUserLastName } from "../v2_actions/auth";
import moment from "moment";
import { photographList } from "../v2_actions/photograph";
import { photographerPriceList } from "../v2_actions/photographer_price";
import { processGalleryPhotographsList } from "v2_actions/process_gallery_photographs";
import { sentrylog } from "../utils/sentry";
import { setEditingGallery, setSelectedGallery, setAddingPhotos } from "../actions/gallery";
import { showSuccess } from "../v2_actions/error";
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { yupResolver } from "@hookform/resolvers/yup";
import { setIsLoading } from "../v2_actions/ui";
import { Modal } from "./layout/Modal";
import { BulkFileUploader } from "../v2_actions/bulk_file_uploader";
import { GalleryUploadForm } from "./GalleryUploadForm";
import { GalleryFields } from "./GalleryEditorSideBarGalleryFields.js";

const useStyles = makeStyles(styles);

const DEFAULT_SHOT_AT_TIME_HOUR = 14;
const disallowsNonAlphaNumericCharactersRegex = /^[a-zA-Z0-9 ]*$/;

const formSchema = yup.object().shape({
  session_name: yup
    .string()
    .matches(
      disallowsNonAlphaNumericCharactersRegex,
      "Special characters not allowed",
    ),
  lat: yup.number().required(),
  lng: yup.number().required(),
});

export const GalleryEditor = ({ match, field_name_prefix, addPhotosMode }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { gallery_id } = useParams();
  const country = getUserStoredCountry();
  const gallery = useSelector(() => galleryList.getObject(gallery_id));
  const user = useSelector(state => state.user.userInfo)
  const galleryPhotographs = useSelector(() =>
    photographList.getGalleryPhotographs(),
  );
  const [tagsVal, setTagsVal] = useState(null);
  const [galleryType, setGalleryType] = useState("");
  const [genreTag, setGenreTag] = useState(null);
  const [openSports, setOpenSports] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [sessionNameVal, setSessionNameVal] = useState("");
  const [descriptionVal, setDescriptionVal] = useState("");
  const [eventGallery, setEventGallery] = useState(null);
  const [album, setAlbum] = useState(null);
  const [savingInProgress, setSavingInProgress] = useState(false);
  const [fileUploadsInProgress, setFileUploadsInProgress] = useState({});
  const numFilesSelectedForUpload = size(fileUploadsInProgress);
  const [galleryId, setGalleryId] = useState(null);
  const [failedPhotoUploads, setFailedPhotoUploads] = useState([]);
  const [openAddGalleryEventLogoDialog, setOpenAddGalleryEventLogoDialog] =
    useState(false);
  const [
    isFailedPhotoUploadDialogOpenReason,
    setIsFailedPhotoUploadDialogOpenReason,
  ] = useState(null);
  const [rejectedFiles, setRejectedFiles] = useState([])
  const [showRejectionsModal, setShowRejectionsModal] = useState(false)
  const [showUploadPhase, setShowUploadPhase] = useState(false)
  const [savedGalleryId, setSavedGalleryId] = useState(null)
  const [bulkUploadCredentials, setBulkUploadCredentials] = useState(null)
  const [bulkUploadInProgress, setBulkUploadInProgress] = useState(false)
  const [bulkUploadProgress, setBulkUploadProgress] = useState({ uploaded: 0, total: 0 })
  const [bulkUploadStatus, setBulkUploadStatus] = useState(null) // 'saving_gallery', 'gallery_created', 'uploading', 'registering', null
  const genreTagOptions = useSelector(() =>
    genreTagDropdownOptions.getAsOptions(),
  );
  const galleryEventOptions = useSelector(() =>
    galleryEventDropdownOptions.getAsOptions(),
  );
  const albumOptions = useSelector(() => albumDropdownOptions.getAsOptions());
  // All events and albums (for the gallery editor Event Details section)
  const allGalleryEventOptions = useSelector(() =>
    allGalleryEventDropdownOptions.getAsOptions(),
  );
  const allAlbumOptions = useSelector(() => allAlbumDropdownOptions.getAsOptions());
  const photographerPrice = useSelector(() =>
    photographerPriceList.getLoggedInPhotographerPrice(),
  );

  const isCreateNewForGallery = matchPath(history.location.pathname, {
    exact: true,
    strict: false,
    path: "/photographer/gallery/new",
  });
  const isCreateNewForPhotoArt = matchPath(history.location.pathname, {
    exact: true,
    strict: false,
    path: "/photographer/photo_art_gallery/new",
  });

  const numFilesCompleted = size(
    filter(
      fileUploadsInProgress,
      (f) =>
        f.status === "success" ||
        f.status == "failed" ||
        f.status == "duplicate",
    ),
  );

  const activityTagOptions = useSelector(() =>
    activityTagDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "activity",
    }),
  );

  let activity_tag_options = activityTagOptions.filter(
    (val) => val.value !== "any",
  );

  const isNewPath = last(window.location.pathname.split("/")) === "new";
  const editGalleryAble = useSelector((state) => state.gallery.editGalleryAble);
  const addingPhotosGallery = useSelector((state) => state.gallery.addingPhotosGallery);
  const selectedGallery = useSelector(
    (state) => editGalleryAble || (isNewPath ? {} : state.gallery.selectedGallery),
  );

  const [activityTags, setActivityTags] = useState(
    activity_tag_options
      .filter((tag) => selectedGallery?.activity_tags?.includes(tag.value))
      .map((i) => i?.original_item) ?? [],
  );

  const defaultValues = {
    lat: get(selectedGallery, "lat", null),
    lng: get(selectedGallery, "lng", null),
    tags: get(selectedGallery, "tags", ""),
    gallery_type: get(gallery, "gallery_type", "photos"),
    description: get(selectedGallery, "description", ""),
    genre_tags: get(selectedGallery, "genre_tags", null),
    activityTags: get(selectedGallery, "activity_tags", []),
    gallery_event: get(selectedGallery, "gallery_event", ""),
    album: get(selectedGallery, "album", ""),
    activityTags: get(selectedGallery, "activity_tags", []),
    session_name: get(selectedGallery, "session_name", null),
    session_name: get(selectedGallery, "session_name", null),
    shot_at_date: selectedGallery?.shot_at_datetime ? (() => { const m = moment.utc(selectedGallery.shot_at_datetime); return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute()); })() : new Date(),
    gallery_password: get(selectedGallery, "gallery_password", null),
    gallery_password: get(selectedGallery, "gallery_password", null),
    time_duration_hours: get(selectedGallery, "time_duration_hours", 2),
    available_to_purchase: get(selectedGallery, "available_to_purchase", true),
    add_gallery_event_logo: get(
      selectedGallery,
      "add_gallery_event_logo",
      null,
    ),
    can_index_for_facial_recognition: get(
      selectedGallery,
      "can_index_for_facial_recognition",
      false,
    ),
    indexed_for_facial_recognition: get(
      selectedGallery,
      "indexed_for_facial_recognition",
    ),
    shot_at_time: selectedGallery?.shot_at_datetime ? (() => { const m = moment.utc(selectedGallery.shot_at_datetime); return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute()); })() : moment(new Date())
        .set({ hour: DEFAULT_SHOT_AT_TIME_HOUR, minute: 0 })
        .toDate(),
    gallery_price: {
      currency_code: get(country, "currency_code"),
      country_code: get(country, "country_code"),
      base_price: get(selectedGallery, ["gallery_price", "base_price"], 0),
      low_res_price: get(
        selectedGallery,
        ["gallery_price", "low_res_price"],
        null,
      ),
      discount1_percentage: get(
        selectedGallery,
        ["gallery_price", "discount1_percentage"],
        0,
      ),
      discount2_percentage: get(
        selectedGallery,
        ["gallery_price", "discount2_percentage"],
        0,
      ),
      discount3_percentage: get(
        selectedGallery,
        ["gallery_price", "discount3_percentage"],
        0,
      ),
      discount4_percentage: get(
        selectedGallery,
        ["gallery_price", "discount4_percentage"],
        0,
      ),
      event_commission_percentage: get(
        selectedGallery,
        ["gallery_price", "event_commission_percentage"],
        0,
      ),
    },
  };

  const formProps = useForm({
    defaultValues,
    resolver: yupResolver(formSchema),
  });
  const {
    reset,
    control,
    setValue,
    getValues,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = formProps;

  const handleActivityTagChange = (event) => {
    setActivityTags(event.target.value);
  };

  const handleGenreTagChange = (genreId) => {
    setGenreTag(genreId);
    setValue("genre_tags", genreId);
  };

  useEffect(() => {
    if (selectedGallery) {
      dispatch(photographList.fetchGalleryPhotographs(selectedGallery.id));
    }
  }, [selectedGallery]);

  useEffect(() => {
    if (gallery && gallery.album) {
      setValue("album", gallery.album, { shouldValidate: true });
    }
    if (gallery && gallery.gallery_type) {
      setGalleryType(gallery.gallery_type);
      setValue("gallery_type", gallery.gallery_type, { shouldValidate: true });
    }
  }, [gallery]);

  useEffect(() => {
    setTimeout(() => {
      setValue("album", get(selectedGallery, "album"));
      setValue("gallery_event", get(selectedGallery, "gallery_event"));
      setValue(
        "can_index_for_facial_recognition",
        get(selectedGallery, "can_index_for_facial_recognition"),
      );
      setValue(
        "indexed_for_facial_recognition",
        get(selectedGallery, "indexed_for_facial_recognition"),
      );
    }, 1000);
  }, [editGalleryAble]);

  useEffect(() => {
    if (eventGallery) {
      setGalleryType("event");
      setValue("gallery_type", "event", { shouldValidate: true });
    } else {
      setValue("gallery_event", "");
    }
  }, [eventGallery]);

  useEffect(() => {
    if (activityTags && openSports === true) {
      setOpenSports(false);
    }
  }, [activityTags]);

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);
  useEffect(() => {
    dispatch(photographerPriceList.ensurePhotographerPriceLoaded());
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
    dispatch(albumDropdownOptions.fetchListIfNeeded());
    dispatch(galleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(genreTagDropdownOptions.fetchListIfNeeded());
    dispatch(allGalleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(allAlbumDropdownOptions.fetchListIfNeeded());
  }, []);

  useEffect(() => {
    dispatch(galleryList.ensureObjectLoaded(gallery_id));
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
    dispatch(albumDropdownOptions.fetchListIfNeeded());
    dispatch(galleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(genreTagDropdownOptions.fetchListIfNeeded());
    dispatch(allGalleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(allAlbumDropdownOptions.fetchListIfNeeded());
  }, [gallery_id]);

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);

  useEffect(() => {
    if (selectedGallery?.gallery_price) {
      return;
    }

    if (gallery_id) {
      return;
    }
    if (!get(photographerPrice, "id")) {
      return;
    }
    const values = Object.assign({}, defaultValues);
    values.gallery_price = clone(photographerPrice);
    reset(values);
  }, [get(photographerPrice, "id")]);

  useEffect(() => {
    if (editGalleryAble) {
      return;
    }
    if (!gallery.id) {
      return;
    }
    const values = Object.assign({}, defaultValues, gallery);
    if (!values.gallery_price) {
      values.gallery_price = clone(defaultValues.gallery_price);
    }
    const m = moment.utc(values.shot_at_datetime);
    values.shot_at_date = new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
    values.shot_at_time = new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
    reset(values);
  }, [gallery.id]);

  const getDetailedValues = (values) => {
    const d = values.shot_at_date;
    const t = values.shot_at_time;
    const shot_at_datetime = moment.utc([
      d.getFullYear(), d.getMonth(), d.getDate(),
      t.getHours(), t.getMinutes(), 0
    ])
    return {
      ...values,
      activity_tags: activityTags.map((val) => val.id),
      gallery_type: eventGallery ? 'event' : 'photos',
      sport_tag_deprecated: null,
      shot_at_datetime,
      gallery_name: createGalleryName({ ...values, shot_at_datetime }),
    }
  }
    
  const onSave = async (values) => {
    setSavingInProgress(true);
    dispatch(setIsLoading(true));
    const detailedValues = getDetailedValues(values)
    clearErrors();

    const on_gallery_save_ok = function (json) {
      const gallery = json;
      const gallery_id = gallery.id;
      dispatch(setIsLoading(false));
      dispatch(galleryList.invalidateList());
      dispatch(photographList.invalidateList());
      dispatch(briefGalleryListForPhotoArt.invalidateList());
      dispatch(setSelectedGallery(gallery))

      if (get(editGalleryAble, "id")) {
        const wasIndexed = get(selectedGallery, "can_index_for_facial_recognition");
        const isNowIndexed = values.can_index_for_facial_recognition;
        if (!wasIndexed && isNowIndexed) {
          dispatch(facialRecognitionList.indexGalleryForFacialRecognition(gallery_id));
        }
        onCancel();
        history.push(`/photographer/map`);
        showSuccess("Success", "Gallery updated")
      } else {
        setSavingInProgress(false);
        dispatch(setEditingGallery(null));
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        dispatch({ type: "GALLERY/ADDPHOTOSPROMPT", addPhotosPromptGallery: gallery });
      }
    };

    return dispatch(galleryList.saveGallery(
      detailedValues, selectedGallery, formProps, on_gallery_save_ok
    ))
  };

  const onCancel = () => {
    dispatch(galleryList.invalidateList());
    dispatch(galleryList.fetchListIfNeeded());
    dispatch(setEditingGallery(null));
    dispatch(setAddingPhotos(null));
  };

  const onBulkUploadClick = async () => {
    const values = getValues()
    const photos = get(values, "files")

    if (!photos || size(photos) === 0) {
      alert('Please add photos first before using bulk upload')
      return
    }

    const detailedValues = getDetailedValues(values)
    
    setBulkUploadInProgress(true)
    setBulkUploadStatus('saving_gallery')

    const onGallerySaved = (gallery) => {
      setBulkUploadStatus('gallery_created')
      
      dispatch(galleryUploadCredentialsList.getFor({
        galleryRef: gallery.id
      })).then((credentials) => {
        setBulkUploadCredentials(credentials)

        const onUploadComplete = (result) => {
          setBulkUploadInProgress(false)
          setBulkUploadProgress({ uploaded: 0, total: 0 })
          setBulkUploadStatus(null)

          dispatch(processGalleryPhotographsList.processGalleryPhotographs(gallery.id))
          dispatch(facialRecognitionList.indexGalleryForFacialRecognition(gallery.id))
          
          const noFailures = result.failures.length === 0
          if (noFailures) {
            if (!gallery.available_to_purchase) {
              dispatch(galleryList.saveObject({ ...gallery, available_to_purchase: true }))
            }
            showSuccess("Success", `${result.successes.length} photos uploaded`)
            dispatch(galleryList.invalidateList())
            dispatch(photographList.invalidateList())
            onCancel()
            history.push("/photographer/map/")
          } else {
            setFailedPhotoUploads(result.failures)
            setIsFailedPhotoUploadDialogOpenReason(
              `${result.failures.length} photos failed to upload. ${result.successes.length} photos uploaded successfully.`
            )
          }
        }

        dispatch(galleryList.savePhotosv3({
          photos,
          credentials,
          gallery,
          fileUploadsInProgress,
          setFileUploadsInProgress,
          setBulkUploadProgress,
          setBulkUploadStatus,
          setBulkUploadInProgress,
          onUploadComplete,
        }))
        
      }
              )
    }

    try {
      dispatch(galleryList.saveGallery(detailedValues, selectedGallery, formProps, onGallerySaved))
    } catch (error) {
      setBulkUploadInProgress(false)
      setBulkUploadProgress({ uploaded: 0, total: 0 })
      setBulkUploadStatus(null)
    }
  }

  const createGalleryName = (values) => {
    let gallery_name;
    const user_last_name = loggedInUserLastName();
    const date = moment.utc(values.shot_at_datetime).format("Do MMM 'YY");
    const first_time = moment.utc(values.shot_at_datetime).format("HH:mm");
    const tag_Name = activityTags.map((tag) => ` ${tag.name}`).toString();

    if (galleryType !== "photo_art") {
      gallery_name = `${date}. ${first_time}, ${values.session_name}`;
    } else {
      gallery_name = values.session_name;
    }
    return gallery_name;
  };

  const handleUnavailableToPurchaseGallery = (event) => {
    setValue("available_to_purchase", !event.target.checked);
  };

  const handleIndexGalleryForFacialRecognition = (event) => {
    const isExistingGallery = get(selectedGallery, "id");
    const wasAlreadyIndexed = get(selectedGallery, "can_index_for_facial_recognition");

    // If existing gallery was already indexed, don't allow turning it off
    if (isExistingGallery && wasAlreadyIndexed && !event.target.checked) {
      return;
    }

    setValue(
      "can_index_for_facial_recognition",
      event.target.checked,
      { shouldValidate: true },
    );
  };

  const handleCloseCustomGalleryEventLogoDialog = () => {
    setOpenAddGalleryEventLogoDialog(false);
  };

  const handleAddGalleryEventLogo = (event) => {
    const addLogoIsChecked = event.target.checked;
    setValue("add_gallery_event_logo", addLogoIsChecked, {
      shouldValidate: true,
    });
    if (addLogoIsChecked) {
      setOpenAddGalleryEventLogoDialog(true);
    }
  };
  const handleHideGallery = (event) => {
    const isAvailableToPurchase = event.target.checked;
    setValue("available_to_purchase", isAvailableToPurchase, {
      shouldValidate: true,
    });
  };

  const handleCloseFailedPhotoUploadDialog = () => {
    setIsFailedPhotoUploadDialogOpenReason(null);
    onCancel();
    history.push("/photographer/map");
  };

  const onClickCancel = () => {
    const hasRejectedFiles = rejectedFiles.length > 0
    if (hasRejectedFiles) {
      setShowRejectionsModal(true)
    } else {
      onCancel();
      history.push("/photographer/map");
    }
  }

  const onCloseRejectionsModal = () => {
    setShowRejectionsModal(false)
    setRejectedFiles([])
  }

  const renderRejectionsModal = () => {
    return (
      <Modal onClose={ onCloseRejectionsModal } title={`Invalid Files`}>
      { map(rejectedFiles, (file) => {
        return (
          <div>{ file.file.name }</div>
        )
      })
      }
      </Modal>
    )
  }

  const renderDetailsForm = () => {
    return (
      <form onSubmit={handleSubmit(onSave, () => {
        const sidebar = document.getElementById("rightSideBar");
        if (sidebar) sidebar.scrollTop = 0;
      })}>
        <GeneralFormErrors formProps={formProps} />
        <Grid container className={classes.rightSideBarWrapper}>
          <Grid item xs={12}>
            <div
              className={classNames(
                classes.sidebarHeading,
                classes.galleryEditorSideBarHeading,
              )}
            >
              {get(
                selectedGallery,
                "gallery_name",
                "Enter New Gallery Details",
              )}
            </div>
          </Grid>
          <Box className={classes.galleryFieldsWrapper}>
            <GalleryFields
              classes={classes}
              MenuClass={MenuClass}
              formProps={formProps}
              openSports={openSports}
              setOpenSports={setOpenSports}
              activityTags={activityTags}
              setActivityTags={setActivityTags}
              selectedGallery={selectedGallery}
              activity_tag_options={activity_tag_options}
              setEventGallery={setEventGallery}
              gallery={gallery}
              gallery_id={gallery_id}
              galleryType={galleryType}
            />
          </Box>
          {savingInProgress && (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <div className={classes.circularProgressWrapper}>
                <div className={classes.circularProgressWhell}>
                  <CircularProgress
                    size={50}
                    mode="indeterminate"
                    style={{ color: "green" }}
                  />
                </div>
              </div>
            </Grid>
          )}
          <Grid item xs={6} className={classes.buttonWrapper} style={detailsFormButtonStyle}>
            <StyledButton
              className={classes.grayButton}
              onClick={onClickCancel}
            >
              Cancel
            </StyledButton>
          </Grid>
          <Grid item xs={6} className={classes.buttonWrapper} style={detailsFormButtonStyle} type="submit">
            <div className={classes.submitAndCancelBtn}>
              <Grid item xs={6}>
                {(
                  <StyledButton
                    type="submit"
                    className={`${classes.buttonWrapper} ${
                      savingInProgress && classes.grayButton
                    }`}
                    disabled={savingInProgress}
                  >
                    {get(editGalleryAble, "id")
                      ? "Update Gallery"
                      : "Submit"}
                  </StyledButton>
                )}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </form>
    );
  };

  const renderForm = () => {
    if (addPhotosMode || showUploadPhase) {
      return (
        <GalleryUploadForm
          addingPhotosGallery={addingPhotosGallery}
          savedGalleryId={savedGalleryId}
          addPhotosMode={addPhotosMode}
          isEditorForPhotoArt={false}
          formProps={formProps}
          user={user}
          country={country}
          bulkUploadInProgress={bulkUploadInProgress}
          bulkUploadStatus={bulkUploadStatus}
          bulkUploadProgress={bulkUploadProgress}
          onBulkUploadClick={onBulkUploadClick}
          fileUploadsInProgress={fileUploadsInProgress}
          setFileUploadsInProgress={setFileUploadsInProgress}
          numFilesCompleted={numFilesCompleted}
          numFilesSelectedForUpload={numFilesSelectedForUpload}
          rejectedFiles={rejectedFiles}
          setRejectedFiles={setRejectedFiles}
          setShowRejectionsModal={setShowRejectionsModal}
        />
      );
    }
    return renderDetailsForm();
  };

  return (
    <div className={classes.galleryEditorPage}>
      <Global styles={global_styles} />
      {!gallery_id && (
        <Box display="flex" alignItems="center" paddingLeft="32px">
          <Typography
            className={classes.titletypography}
            style={{ textAlign: "center" }}
          >
            <font className={classes.loadGalleryTitle}>
              {/* Load up a New Gallery */}
            </font>
          </Typography>
        </Box>
      )}
      {savingInProgress && (
        <div className={classes.saving}>
          <div className={classes.progressWrapper}>
            <LoaderPercentProgressContainer />
          </div>
        </div>
      )}
      {renderForm()}
      <FailedPhotoUploadDialog
        open={isFailedPhotoUploadDialogOpenReason !== null}
        failedPhotoUploads={failedPhotoUploads}
        reason={isFailedPhotoUploadDialogOpenReason}
        handleClose={handleCloseFailedPhotoUploadDialog}
      />
      {showRejectionsModal && renderRejectionsModal()}
    </div>
  );
};

const global_styles = css`
  #rightSideBar .MuiInput-underline::before,
  #rightSideBar .MuiInput-underline::after {
    display: none;
  }
  #passwordFieldWrapper p .MuiFormControl-root {
    width: 100%;
  }
`;

const MenuClass = {
  textField: {
    color: "black",
    fontWeight: "800",
    fontSize: "12px",
    textAlign: "left",
  },
  input: {
    color: "black",
    fontWeight: "800",
    fontSize: "12px",
    textAlign: "left",
  },
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  BlueBtn: {
    background: "#75A9F9",
  },
  input: {
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "blue",
    },
  },
  inputLabel: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    color: "red",
  },
  circularProgressWheelWrapper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-start",
    height: "100%",
    transform: `translate(-50%, -50%)`,
    zIndex: 999,
  },
  circularProgressWheel: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50%",
  },
  smallTextField: {
    margin: "0px 10px 0px 0px",
    background: "#ebebeb",
    height: 23,
    width: 45,
    // textDecoration: "underline",
    //
    "& input": {
      marginTop: 5,
      textAlign: "center",
      textDecoration: "none",
      padding: 0,
    },
  },
};

const detailsFormButtonStyle = {
  marginTop: 24,
};
